/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Position_X_RightInputs */

const en_input_position_x_right = /** @type {(inputs: Input_Position_X_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Right`)
};

const fr_input_position_x_right = /** @type {(inputs: Input_Position_X_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Droite`)
};

const de_input_position_x_right = /** @type {(inputs: Input_Position_X_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechts`)
};

const it_input_position_x_right = /** @type {(inputs: Input_Position_X_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giusto`)
};

const ru_input_position_x_right = /** @type {(inputs: Input_Position_X_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Верно`)
};

const es_input_position_x_right = /** @type {(inputs: Input_Position_X_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bien`)
};

const zh_cn2_input_position_x_right = /** @type {(inputs: Input_Position_X_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正确的`)
};

const ja_input_position_x_right = /** @type {(inputs: Input_Position_X_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`右`)
};

const hi_input_position_x_right = /** @type {(inputs: Input_Position_X_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सही`)
};

const pt_pt2_input_position_x_right = /** @type {(inputs: Input_Position_X_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Certo`)
};

/**
* | output |
* | --- |
* | "Right" |
*
* @param {Input_Position_X_RightInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_x_right = /** @type {((inputs?: Input_Position_X_RightInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_X_RightInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_input_position_x_right(inputs)
	if (locale === "de") return de_input_position_x_right(inputs)
	if (locale === "it") return it_input_position_x_right(inputs)
	if (locale === "ru") return ru_input_position_x_right(inputs)
	if (locale === "es") return es_input_position_x_right(inputs)
	if (locale === "zh-CN") return zh_cn2_input_position_x_right(inputs)
	if (locale === "ja") return ja_input_position_x_right(inputs)
	if (locale === "hi") return hi_input_position_x_right(inputs)
	if (locale === "pt-PT") return pt_pt2_input_position_x_right(inputs)
	return en_input_position_x_right(inputs)
});